import React from 'react';
import ReactDOM from 'react-dom';
import 'materialize-css';
import 'materialize-css/dist/css/materialize.min.css';
import './styles/index.scss'

import Routes from './routes';

ReactDOM.render(<Routes />, document.getElementById('root'));
